import { Link } from "react-router-dom";
import s from "../clinic.module.css";

export default function AdminDoctorScheduleHelp() {
  return (
    <details className={s.scheduleHelp}>
      <summary>Как считаются слоты на портале</summary>
      <ol className={s.scheduleHelpList}>
        <li>
          <strong>Шаблон недели</strong> задаёт рабочие часы (можно «чётные /
          нечётные» недели).
        </li>
        <li>
          <strong>Исключения и отпуск</strong> закрывают день или добавляют
          доп. занятие.
        </li>
        <li>
          Из свободного времени вычитаются <strong>уже занятые записи</strong>{" "}
          и буфер клуба.
        </li>
        <li>
          Остаток нарезается по <strong>длительности услуги</strong> (вкладка
          «Услуги» тренера важнее справочника) и <strong>шагу слотов</strong>.
        </li>
        <li>
          <strong>Ручная сетка</strong> на дату полностью заменяет автоматику.
        </li>
        <li>
          <strong>Правила записи</strong> — лимит записей в день и перерыв
          между занятиями.
        </li>
      </ol>
      <p className={s.scheduleHelpFoot}>
        Шаг и буфер:{" "}
        <Link to="/manage/app/settings">Настройки клуба</Link>. Проверка: блок
        «Превью для клиента» ниже — выберите услугу.
      </p>
    </details>
  );
}
